export default __webpack_public_path__ + "static/media/travel.c3599fbb.jpg";